const request = {
    invalid_input: 'Nieprawidłowe dane wejściowe. {{details}}',
    general: 'Wystąpił błąd żądania.',
    range_not_satisfiable: 'Zakres nie do zrealizowania.',
};
export default Object.freeze(request);
